import React, { useState, SyntheticEvent } from 'react';
import { Tabs, Tab, Grid, Button, Box } from '@mui/material';
import { useNavigate } from 'react-router-dom';
// import { SlideshowLightbox } from 'lightbox.js-react';
import HomeSmallHeader from '../../../../components/component/resused-component/HomeSmallHeader';
import ContanierHeading from '../../../../components/component/resused-component/ContanierHeading';

const images = {
	all: [
		'/assets/gallery-images/gallery-wedding/wedding-1.jpg',
		'/assets/gallery-images/gallery-wedding/wedding-2.jpg',
		'/assets/gallery-images/galler-housewarming/housewarming1.jpg',
		'/assets/gallery-images/gallery-seemantham/Seemantham3.jpg',
		'/assets/gallery-images/galler-housewarming/housewarming6.jpg',
		'/assets/gallery-images/galler-housewarming/housewarming7.jpg',
		'/assets/gallery-images/galler-housewarming/housewarming3.jpg',
		'/assets/gallery-images/galler-housewarming/housewarming4.jpg',
		'/assets/gallery-images/galler-housewarming/housewarming5.jpg',
		'/assets/gallery-images/galler-housewarming/housewarming6.jpg',
		'/assets/gallery-images/galler-housewarming/housewarming7.jpg',
		'/assets/gallery-images/galler-housewarming/housewarming8.jpg',
	],
	wedding: [
		'/assets/gallery-images/gallery-wedding/wedding-1.jpg',
		'/assets/gallery-images/gallery-wedding/wedding-2.jpg',
		'/assets/gallery-images/gallery-wedding/wedding-3.jpg',
		'/assets/gallery-images/gallery-wedding/wedding-4.jpg',
		'/assets/gallery-images/gallery-wedding/wedding-5.jpg',
		'/assets/gallery-images/gallery-wedding/wedding-6.jpg',
		'/assets/gallery-images/gallery-wedding/wedding-7.jpg',
		'/assets/gallery-images/gallery-wedding/wedding-8.png',
		'/assets/gallery-images/gallery-wedding/wedding-9.jpg',
		'/assets/gallery-images/gallery-wedding/wedding-10.png',
		'/assets/gallery-images/gallery-wedding/wedding-11.png',
		'/assets/gallery-images/gallery-wedding/wedding-12.png',
		'/assets/gallery-images/gallery-wedding/wedding-13.png',
		'/assets/gallery-images/gallery-wedding/wedding-14.png',
	],
	engagement: [
		'/assets/gallery-images/gallery-engagement/eng1.jpg',
		'/assets/gallery-images/gallery-engagement/eng2.jpg',
		'/assets/gallery-images/gallery-engagement/eng3.jpg',
		'/assets/gallery-images/gallery-engagement/eng4.jpg',
		'/assets/gallery-images/gallery-engagement/eng5.jpg',
		'/assets/gallery-images/gallery-engagement/eng6.jpg',
		'/assets/gallery-images/gallery-engagement/eng7.jpg',
		'/assets/gallery-images/gallery-engagement/eng8.jpg',
	],
	seemantham: [
		'/assets/gallery-images/gallery-seemantham/Seemantham3.jpg',
		'/assets/gallery-images/gallery-seemantham/Seemantham4.jpg',
		'/assets/gallery-images/gallery-seemantham/Seemantham5.jpg',
		'/assets/gallery-images/gallery-seemantham/Seemantham1.jpg',
		'/assets/gallery-images/gallery-seemantham/Seemantham2.jpg',
		'/assets/gallery-images/gallery-seemantham/Seemantham6.jpg',
		'/assets/gallery-images/gallery-seemantham/Seemantham7.jpg',
		'/assets/gallery-images/gallery-seemantham/Seemantham8.jpg',
	],
	birthday: [
		'/assets/gallery-images/gallery-birthday/birthday1.jpg',
		'/assets/gallery-images/gallery-birthday/birthday2.jpg',
		'/assets/gallery-images/gallery-birthday/birthday3.jpg',
		'/assets/gallery-images/gallery-birthday/birthday4.jpg',
		'/assets/gallery-images/gallery-birthday/birthday5.jpg',
		'/assets/gallery-images/gallery-birthday/birthday6.jpg',
		'/assets/gallery-images/gallery-birthday/birthday7.jpg',
		'/assets/gallery-images/gallery-birthday/birthday8.jpg',
	],
	houseWarming: [
		'/assets/gallery-images/galler-housewarming/housewarming1.jpg',
		'/assets/gallery-images/galler-housewarming/housewarming2.jpg',
		'/assets/gallery-images/galler-housewarming/housewarming3.jpg',
		'/assets/gallery-images/galler-housewarming/housewarming4.jpg',
		'/assets/gallery-images/galler-housewarming/housewarming5.jpg',
		'/assets/gallery-images/galler-housewarming/housewarming6.jpg',
		'/assets/gallery-images/galler-housewarming/housewarming7.jpg',
		'/assets/gallery-images/galler-housewarming/housewarming8.jpg',
	],
	Sathabhishekam: [
		'/assets/gallery-images/gallery-shastiaptha-poorthi/Shastiaptha-Poorthi-1.jpg',
		'/assets/gallery-images/gallery-shastiaptha-poorthi/Shastiaptha-Poorthi2.jpg',
		'/assets/gallery-images/gallery-shastiaptha-poorthi/Shastiaptha-Poorthi3.jpg',
		'/assets/gallery-images/gallery-shastiaptha-poorthi/Shastiaptha-Poorthi4.jpg',
		'/assets/gallery-images/gallery-shastiaptha-poorthi/Shastiaptha-Poorthi5.jpg',
		'/assets/gallery-images/gallery-shastiaptha-poorthi/Shastiaptha-Poorthi6.jpg',
		'/assets/gallery-images/gallery-shastiaptha-poorthi/Shastiaptha-Poorthi7.jpg',
		'/assets/gallery-images/gallery-shastiaptha-poorthi/Shastiaptha-Poorthi8.jpg',
	],

	corporate: [
		'/assets/gallery-images/gallery-corporate/coporate1.jpg',
		'/assets/gallery-images/gallery-corporate/coporate2.jpg',
		'/assets/gallery-images/gallery-corporate/coporate3.jpg',
		'/assets/gallery-images/gallery-corporate/coporate4.jpg',
		'/assets/gallery-images/gallery-corporate/coporate-5.jpg',
		'/assets/gallery-images/gallery-corporate/coporate6.jpg',
		'/assets/gallery-images/gallery-corporate/coporate7.jpg',
		'/assets/gallery-images/gallery-corporate/coporate8.jpg',
	],

	otherEvents: [
		'/assets/gallery-images/gallery-allevents/event1.jpg',
		'/assets/gallery-images/gallery-allevents/event2.jpg',
		'/assets/gallery-images/gallery-allevents/event3.jpg',
		'/assets/gallery-images/gallery-allevents/event4.jpg',
		'/assets/gallery-images/gallery-allevents/event5.jpg',
		'/assets/gallery-images/gallery-allevents/event6.jpg',
		'/assets/gallery-images/gallery-allevents/event7.jpg',
		'/assets/gallery-images/gallery-allevents/event8.jpg',
		'/assets/gallery-images/gallery-allevents/image3.png',
		'/assets/gallery-images/gallery-allevents/image4.png',
	],
};

const GalleryContainer = () => {
	const [tabValue, setTabValue] = useState<number>(0);
	const navigate = useNavigate();

	const handleTabChange = (event: SyntheticEvent, newValue: number) => {
		setTabValue(newValue);
	};

	const handleViewAll = () => {
		navigate('/gallery');
	};

	const currentImages = images[Object.keys(images)[tabValue] as keyof typeof images].slice(0, 8);

	return (
		<Box
			sx={{
				flexGrow: 1,
				p: 2,
				pb: 5,
				backgroundImage: 'url(/assets/Section.svg)',
				backgroundSize: 'cover',
				backgroundPosition: 'center',
				backgroundRepeat: 'repeat-y',
				position: 'relative',
			}}
		>
			<HomeSmallHeader text=" Latest Events" />

			<ContanierHeading name="Our Social & Professional Events Gallery" />
			<Grid container spacing={2} style={{ margin: '20px 5px' }}>
				<Grid
					size={{ xs: 12, sm: 12, md: 2, lg: 2 }}
					sx={{ display: { xs: 'none', sm: 'none', md: 'block' } }}
				/>
				<Grid size={{ xs: 12, sm: 12, md: 8, lg: 8 }}>
					<Box display="flex" justifyContent={'center'} alignItems={'center'}>
						<Tabs
							value={tabValue}
							onChange={handleTabChange}
							// centered
							variant="scrollable"
							scrollButtons
							allowScrollButtonsMobile
							aria-label="scrollable force tabs example"
						>
							<Tab label="All Events" />
							<Tab label="Wedding" />
							<Tab label="Engagements" />
							<Tab label="Seemantham" />
							<Tab label="Birthday" />
							<Tab label="House Warming" />
							<Tab label="Sathabhishekam" />
							<Tab label="Corporate Catering" />
							<Tab label="Other events" />
						</Tabs>
						<Button
							className="mb-2"
							variant="text"
							color="primary"
							onClick={handleViewAll}
						>
							View All
						</Button>
					</Box>
					<Grid container spacing={2} style={{ marginTop: '20px' }}>
						{currentImages.map((imageUrl: string, index: number) => (
							<Grid size={{ xs: 6, sm: 4, md: 4, lg: 3 }} key={index}>
								{/* <SlideshowLightbox> */}
								<img
									src={imageUrl}
									alt={`Image ${index}`}
									style={{ width: '100%', height: 'auto', borderRadius: '10px' }}
								/>
								{/* </SlideshowLightbox> */}
							</Grid>
						))}
					</Grid>
				</Grid>
			</Grid>
		</Box>
	);
};

export default GalleryContainer;
